module.exports = __webpack_public_path__ + "static/media/table-padding-horizontal.01b7b16d.png";